var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndpageEllipseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 133,
    viewBox: "0 0 130 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.2591 0.101288C103.647 2.77426 116.025 9.26353 126.086 18.8839C136.147 28.5042 143.518 40.8986 147.42 54.7582C151.322 68.6178 151.61 83.4282 148.255 97.6256C144.9 111.823 138.025 124.88 128.357 135.419C118.689 145.958 106.586 153.586 93.327 157.499C80.0676 161.413 66.1437 161.465 53.0255 157.651C39.9073 153.838 28.0818 146.299 18.7976 135.832C9.51344 125.365 3.11519 112.358 0.278492 98.1837L48.0849 86.2305C49.097 91.2874 51.3797 95.9281 54.6921 99.6625C58.0044 103.397 62.2235 106.086 66.9037 107.447C71.5839 108.808 76.5516 108.789 81.2822 107.393C86.0128 105.997 90.3307 103.275 93.7801 99.5151C97.2294 95.7552 99.6821 91.0967 100.879 86.0314C102.076 80.9662 101.973 75.6822 100.581 70.7374C99.1889 65.7927 96.5592 61.3707 92.9697 57.9384C89.3802 54.5062 84.9641 52.1909 80.1877 51.2373L90.2591 0.101288Z",
    fill: "url(#paint0_linear_2542_4584)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2542_4584",
    x1: -0.760691,
    y1: 91.6853,
    x2: 150.679,
    y2: 73.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E297DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpageEllipseRight);
export default __webpack_public_path__ + "static/media/EndpageEllipseRight.62a2edac0428decf31a9cd3700e40295.svg";
export { ForwardRef as ReactComponent };